<template>
  <van-pull-refresh :disabled="disablePullRefresh" v-model="refreshing" @refresh="onRefresh" :style="list.length>0?{}:{height:'100%'}">
    <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <div v-for="(item,index) in list" :key="index" >
        <slot :item="item" :index="index"/>
      </div>
    </van-list>
  </van-pull-refresh>
</template>


<script setup>
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {watch} from "vue";

  const list = ref([]);
  const loading = ref(false);
  const finished = ref(false);
  const refreshing = ref(false);
  let useHttp = useHHttp();
  const props = defineProps(["path","exParams","respCallback","limit","disablePullRefresh"]);


  watch(() => props.exParams, async () => {
    list.value = [];
    onLoad();
  });

  function onLoad (){
    if (refreshing.value) {
      list.value = [];
      refreshing.value = false;
    }
    //request
    let requestParams = {
      Start:list.value.length,
      Limit:props.limit??24,
    };
    if(props.exParams){
      for(let key in props.exParams){
        requestParams[key] = props.exParams[key];
      }
    }
    useHttp.request(props.path,(resp)=>{
      if (props.respCallback != null) {
        props.respCallback(resp);
      }
      loading.value = false;
      list.value = [...list.value, ...(resp["List"]??[])];
      if(resp["List"] == null){
        finished.value = true;
      }
    },{
      params:requestParams,
      forceToastErrorMsg: true,
      isShowLoading: false,
    });
  }

  function onRefresh(){
    // 清空列表数据
    list.value = [];

    //重新设置finish状态
    finished.value = false;

    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    loading.value = true;
    onLoad();
  }
</script>


<style scoped>


</style>
